import { createSelector } from '@reduxjs/toolkit';

import { ReduxState } from '../types';

// Base slice selectors
const selectAuth = (state: ReduxState) => state.auth;

export const selectDelegateMode = createSelector([selectAuth], auth => !!auth.user && auth.user.id !== auth.user.authUser.id);
